import { useEffect, useRef, useState } from "react";

const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20as%20áreas%20de%20atuação.";

const AREAS = [
  {
    category: "Empresarial",
    icon: "ri-building-2-line",
    color: "bg-rose-primary",
    items: [
      {
        title: "Consultoria Jurídica Preventiva",
        desc: "Análise de riscos e implementação de boas práticas jurídicas para proteger o patrimônio e as operações da sua empresa, reduzindo litígios e garantindo conformidade legal.",
        cta: "Saiba mais",
      },
      {
        title: "Direito do Trabalho Empresarial",
        desc: "Gestão de contratos, compliance trabalhista, demissões e defesa em reclamações trabalhistas com estratégia e foco em resultados.",
        cta: "Saiba mais",
      },
      {
        title: "Direito Previdenciário Empresarial",
        desc: "Revisão de tributos previdenciários, planejamento e defesa em processos administrativos e judiciais perante INSS e Receita Federal.",
        cta: "Saiba mais",
      },
      {
        title: "Direito Empresarial",
        desc: "Contratos empresariais, constituição e dissolução societária, proteção de ativos e estrutura jurídica sólida para o seu negócio.",
        cta: "Saiba mais",
      },
      {
        title: "Contencioso Estratégico",
        desc: "Gestão de litígios com estratégia e foco na eficiência processual, minimizando impactos financeiros e operacionais ao negócio.",
        cta: "Saiba mais",
      },
    ],
  },
  {
    category: "Pessoa Física",
    icon: "ri-user-3-line",
    color: "bg-rose-dark",
    items: [
      {
        title: "Direito Previdenciário",
        desc: "Aposentadorias, benefícios de incapacidade, pensões e revisões para trabalhadores CLT, autônomos e servidores públicos. Defendemos seus direitos junto ao INSS e regimes próprios.",
        cta: "Saiba mais",
      },
      {
        title: "Direitos do Servidor Público",
        desc: "Assessoria jurídica especializada para servidores públicos: estabilidade, remoção, promoção, aposentadoria especial, adicional de insalubridade, processos administrativos disciplinares (PAD) e impugnação de penalidades.",
        cta: "Saiba mais",
      },
      {
        title: "Direito do Trabalho",
        desc: "Rescisões, horas extras, verbas rescisórias, assédio moral e toda a defesa dos direitos do trabalhador, tanto na esfera celetista quanto para vínculos atípicos.",
        cta: "Saiba mais",
      },
      {
        title: "Direito Civil",
        desc: "Contratos, responsabilidade civil, indenizações, direito de família, inventário e questões patrimoniais para pessoas físicas em todo o Brasil.",
        cta: "Saiba mais",
      },
    ],
  },
];

export default function AreasSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [activeCategory, setActiveCategory] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-area");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="areas" ref={sectionRef} className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="reveal-area opacity-0 translate-y-8 transition-all duration-700 flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-10 bg-rose-primary" />
            <span className="text-rose-primary text-xs font-medium uppercase tracking-widest">Áreas de Atuação</span>
            <div className="h-px w-10 bg-rose-primary" />
          </div>
          <h2 className="reveal-area opacity-0 translate-y-8 transition-all duration-700 font-heading text-4xl lg:text-5xl text-grafite font-semibold mb-4">
            Nossa expertise jurídica
          </h2>
          <p className="reveal-area opacity-0 translate-y-8 transition-all duration-700 text-grafite/60 text-base max-w-xl mx-auto">
            Cobertura jurídica completa para proteger tanto o seu negócio quanto os seus direitos individuais.
          </p>
        </div>

        {/* ── DESKTOP layout ── */}
        <div className="hidden md:flex flex-col gap-12">
          {AREAS.map((area) => (
            <div key={area.category}>
              <div className="reveal-area opacity-0 translate-y-8 transition-all duration-700 flex items-center gap-3 mb-6">
                <div className={`w-7 h-7 flex items-center justify-center ${area.color} rounded-full`}>
                  <i className={`${area.icon} text-white text-xs`} />
                </div>
                <span className="text-grafite font-semibold text-sm uppercase tracking-wide">{area.category}</span>
                <div className="flex-1 h-px bg-gray-light" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {area.items.map((item) => (
                  <div
                    key={item.title}
                    className="reveal-area opacity-0 translate-y-8 transition-all duration-700 group p-6 rounded-xl border border-gray-light hover:border-rose-primary/40 hover:bg-rose-pale/20 transition-all"
                  >
                    <div className="flex items-start justify-between mb-4">
                      <h3 className="text-grafite font-semibold text-base leading-snug flex-1 pr-3">{item.title}</h3>
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-arrow-right-up-line text-rose-primary text-sm opacity-0 group-hover:opacity-100 transition-opacity" />
                      </div>
                    </div>
                    <p className="text-grafite/55 text-sm leading-relaxed mb-5">{item.desc}</p>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-rose-primary text-xs font-medium hover:text-rose-dark transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.cta}
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-xs" />
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* ── MOBILE carousel ── */}
        <div className="flex md:hidden flex-col gap-10">
          {AREAS.map((area, aIdx) => (
            <div key={area.category}>
              {/* Category label */}
              <div className="flex items-center gap-3 mb-5">
                <div className={`w-7 h-7 flex items-center justify-center ${area.color} rounded-full`}>
                  <i className={`${area.icon} text-white text-xs`} />
                </div>
                <span className="text-grafite font-semibold text-sm uppercase tracking-wide">{area.category}</span>
                <div className="flex-1 h-px bg-gray-light" />
              </div>

              {/* Scrollable cards */}
              <div className="overflow-x-auto pb-4 -mx-6 px-6 snap-x snap-mandatory scroll-smooth flex gap-4 no-scrollbar">
                {area.items.map((item) => (
                  <div
                    key={item.title}
                    className="snap-start flex-shrink-0 w-[78vw] max-w-xs p-6 rounded-xl border border-gray-light bg-white"
                    style={{ scrollSnapAlign: "start" }}
                  >
                    <h3 className="text-grafite font-semibold text-base leading-snug mb-3">{item.title}</h3>
                    <p className="text-grafite/55 text-sm leading-relaxed mb-5">{item.desc}</p>
                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 text-rose-primary text-xs font-medium cursor-pointer whitespace-nowrap"
                    >
                      {item.cta}
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-xs" />
                      </div>
                    </a>
                  </div>
                ))}
              </div>

              {/* Dot indicators */}
              <div className="flex items-center justify-center gap-1.5 mt-3">
                {area.items.map((_, i) => (
                  <div
                    key={i}
                    className={`rounded-full transition-all duration-200 ${
                      activeCategory === aIdx * 10 + i
                        ? "w-4 h-1.5 bg-rose-primary"
                        : "w-1.5 h-1.5 bg-gray-light"
                    }`}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
